"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _SuccessOutlined = _interopRequireDefault(require("./SuccessOutlined"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SnackbarView = function SnackbarView(props) {
  var count = props.count,
    open = props.open,
    onClose = props.onClose;
  if (open) {
    setTimeout(function () {
      onClose();
    }, 3000);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Snackbar, {
    className: "snackBar",
    open: open,
    autoHideDuration: 3000,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    message: /*#__PURE__*/_react.default.createElement("div", {
      className: "snackBarMessage"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "snackBarMessageIcon"
    }, /*#__PURE__*/_react.default.createElement(_SuccessOutlined.default, null), ' '), /*#__PURE__*/_react.default.createElement("span", {
      className: "snackBarText"
    }, count, ' ', "File(s) successfully added to your cart"))
  }));
};
var _default = SnackbarView;
exports.default = _default;